module.exports = __webpack_public_path__ + "img/columns-solid.0dfe1764.svg";